(function () {
    'use strict';

    /*
     * General toggle util.
     *
     * Usage:
     * Add this html attribute to the trigger: data-toggle="{target}"
     */

    var toggles = document.querySelectorAll('[data-toggle]');
    if (!toggles) return;

    for (var i = 0; i < toggles.length; i++) {
        toggles[i].addEventListener("click", function () {
            var trigger = this;
            var target = document.querySelectorAll(this.dataset.toggle);

            var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                trigger.setAttribute('aria-expanded', 'false');
            } else {
                trigger.setAttribute('aria-expanded', 'true');
            }
            target.forEach((element) => element.classList.toggle('hidden'));
        });
    }
})();